import React, { FC } from 'react';

import { userPic } from '../../../../assets/images';
import { ScorerDataStyled } from './ScorerData.Styles';

interface IProps {
  image?: string;
  firstName: string;
  lastName: string;
}

const ScorerData: FC<IProps> = props => {
  const { image, firstName, lastName } = props;

  return (
    <ScorerDataStyled className="scorer-data">
      <img src={image || userPic} alt={`${firstName} ${lastName}`} />

      <div className="scorer-name">
        {firstName} {lastName}
      </div>
    </ScorerDataStyled>
  );
};

export default ScorerData;
